import { GET_COMPENSATION_TYPES } from "../../../../enums/Request/request.types";

export const getCompensationTypesAction = (data) => {
    return {
        type: GET_COMPENSATION_TYPES,
        payload: data,
    };
};
